import {
   Practitioner,
   PractitionerProvidingPrivateMedicalServiceQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';

import { UseCqrsQueryResult, useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';

export const useCqrsSearchPractitionerProvidingPrivateMedicalService = (): UseCqrsQueryResult<Practitioner[]> => {
   return useCqrsSearch<Practitioner>(() => {
      const query = new PractitionerProvidingPrivateMedicalServiceQuery();
      return query;
   }, paginations.all());
};
